// extracted by mini-css-extract-plugin
export default {"root":"header_root__8KSOU","scrolled":"header_scrolled__kIhV6","logo":"header_logo__E5XQy","leftSide":"header_leftSide__I6Uvp","navbar":"header_navbar__dWZRb"};